// components/Layout.jsx
import React from 'react';
import NavbarEmpty from './NavbarEmpty';
import Footer from './Footer';

const LayoutLogin = ({ children }) => {
  return (
    <div
      className="layout-container"
      style={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh' 
      }}
    >
      <NavbarEmpty />
      <div
        className="full-screen-div"
        style={{
          backgroundImage: `url('/assets/desktop.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          paddingTop: '53px',
          paddingBottom: '40px',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          flex: '1 1 auto',
        }}
      >
        <div
          className="content-container"
          style={{
            flex: '1 1 auto',
            paddingTop: '15px',
            paddingBottom: '15px',
            paddingLeft: '15px',
            paddingRight: '15px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            minHeight: 0,
          }}
        >
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default LayoutLogin;
